import { useFormContext, useWatch } from 'react-hook-form';
import { AdminFormRow, AdminFormSection } from '@ui';
import { FacilityLocationDetails } from '@lp/features/admin/forms/components/FacilityLocationDetails';
import { ControlledTextInput } from '@lp/features/admin/forms/components/inputs/ControlledTextInput';
import { ControlledPhoneInput } from '@lp/features/admin/forms/components/inputs/ControlledPhoneInput';
import { TMDXFile } from '@/api/apis/files';
import { NewLogisticProviderForm } from '../types';
import { getFileUrl } from '@/api/utils';
import { EUROPE_REGION_ID, NA_REGION_ID } from '@/constants/serviceRegion.constants';
import { CoverageSection } from './CoverageSection/CoverageSection';

export const LogisticProviderForm = ({
  isPartnerProvider,
  isReadOnly = false,
}: {
  isPartnerProvider?: boolean;
  isReadOnly?: boolean;
}) => {
  const { control, setValue } = useFormContext<NewLogisticProviderForm>();
  const logoPath = useWatch({ control, name: 'logoPath' });

  const onImageChange = (file: TMDXFile) => {
    setValue('image', file);
  };

  return (
    <>
      <AdminFormSection
        title={`${isPartnerProvider ? 'Supplemental Lift' : 'TX Center'} Provider Details`}
        withAvatar
        imageUrl={getFileUrl(logoPath)}
        onImageChange={onImageChange}
        isReadOnly={isReadOnly}
        type="transport"
      >
        <AdminFormRow title="Provider Name" isRequired>
          <ControlledTextInput
            name="name"
            aria-label="Provider Name"
            isDisabled={isReadOnly}
            errorMessage={
              isPartnerProvider ? 'Provide Supplemental Lift Provider name' : 'Provide TX Center Provider name'
            }
          />
        </AdminFormRow>
        <AdminFormRow title="Email" isRequired>
          <ControlledTextInput name="email" aria-label="Contact Email" type="email" isDisabled={isReadOnly} />
        </AdminFormRow>
        <AdminFormRow title="Primary Phone" isRequired inputWrapperClass="max-w-76.5">
          <ControlledPhoneInput name="primaryPhone" disabled={isReadOnly} />
        </AdminFormRow>
        <AdminFormRow title="Secondary Phone" inputWrapperClass="max-w-76.5">
          <ControlledPhoneInput name="secondaryPhone" disabled={isReadOnly} />
        </AdminFormRow>
        <AdminFormRow title="Aircraft Type">
          <ControlledTextInput name="aircraftType" aria-label="Aircraft Type" isDisabled={isReadOnly} />
        </AdminFormRow>
      </AdminFormSection>
      <CoverageSection title="North America Coverage" serviceRegionId={NA_REGION_ID} isReadOnly={isReadOnly} />
      <CoverageSection title="Europe Coverage" serviceRegionId={EUROPE_REGION_ID} isReadOnly={isReadOnly} />
      <AdminFormSection title="Official Address">
        <FacilityLocationDetails isReadOnly={isReadOnly} isRequired={false} />
      </AdminFormSection>
    </>
  );
};
